import { getURLParameter } from './functions'

const debug = false;
if (debug) console.log('%cDEBUG-MODE', 'color: #ff0000');
else console.log('%cPRODUCATION-MODE', 'color: #00ff00');


/*********************************
 *      GLOBAL VARIABLES
 *********************************/
//TODO: alle Variablen und Konstanten prüfen, erklären und beschreiben wie sie gesetzt werden sollten in welcher Umgebung (Test lokal, cmeassist-dev und cmeassist)

// -- url to node-backend
const backendVersion = 'v2';
//const backendUrl = !debug ? `https://cmeassist.academy2.de/backend/api/${backendVersion}` : `http://localhost:8080/api/${backendVersion}`;
var backendUrl = !debug ? `https://cmeassist-dev.academy2.de/backend/api/${backendVersion}` : `http://localhost:8080/api/${backendVersion}`;

// -- only display questions -> if aussendienst- or questionsOnly-parameter got passed
const onlyQuestions = getURLParameter().ad_email || getURLParameter().onlyQuestions ? true : false;


// -- check if this app is running on cmeassist
const thisUrl = window.location.hostname;
if (thisUrl.includes('dev')) {
    backendUrl = !debug ? `https://cmeassist-dev.academy2.de/backend/api/${backendVersion}` : `http://localhost:8080/api/${backendVersion}`;
} else {
    backendUrl = !debug ? `https://cmeassist.academy2.de/backend/api/${backendVersion}` : `http://localhost:8080/api/${backendVersion}`;
}
console.log('thisUrl: ', thisUrl);
console.log('backendUrl: ', backendUrl);
const isOnServer = ((thisUrl && backendUrl.includes(thisUrl)) || debug) ? true : false;


// -- const suppoert-info
const supportInfo = "<div>+49911 9652250 oder per E-Mail an: <u><a href='mailto:solution@cmeducation.de'>solution@cmeducation.de</a></u></div>";



export { backendUrl, isOnServer, onlyQuestions, supportInfo }